/**
 * analytics.js — Único módulo autorizado para llamar window.fbq.
 *
 * Reglas:
 * - Solo dispara eventos en producción (NODE_ENV === 'production').
 * - Si window.fbq no existe o no es función, sale silenciosamente.
 * - Ningún componente debe llamar window.fbq directamente.
 */

const isProduction = process.env.NODE_ENV === 'production';

/**
 * Llamada segura a fbq. Si el Pixel no cargó o no estamos en producción,
 * la función no hace nada y no lanza errores.
 */
function safeFbq(...args) {
  if (!isProduction) return;
  try {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq(...args);
    }
  } catch (_) {
    // Salida silenciosa: nunca romper la aplicación por tracking
  }
}

// ---------------------------------------------------------------------------
// Funnel de Usuarios
// ---------------------------------------------------------------------------

/** PageView SPA — se dispara en cada cambio de ruta por RouteTracker */
export function trackPageView() {
  safeFbq('track', 'PageView');
}

/**
 * Lead — se dispara únicamente tras respuesta exitosa de POST /api/tickets.
 * No se usa en el funnel profesional.
 */
export function trackLead() {
  safeFbq('track', 'Lead');
}

// ---------------------------------------------------------------------------
// Funnel Profesional
// ---------------------------------------------------------------------------

/**
 * ProfessionalSignupStarted (custom) — se dispara la primera vez que el
 * usuario entra en modo Registro dentro de /provider-auth.
 * No se dispara para Login.
 */
export function trackProfessionalSignupStarted() {
  safeFbq('trackCustom', 'ProfessionalSignupStarted');
}

/**
 * ProfessionalDocumentsCompleted (custom) — se dispara una sola vez cuando
 * los tres documentos requeridos están seleccionados.
 * No vuelve a dispararse si el usuario reemplaza archivos.
 */
export function trackProfessionalDocumentsCompleted() {
  safeFbq('trackCustom', 'ProfessionalDocumentsCompleted');
}

/**
 * CompleteRegistration (estándar Meta) — se dispara únicamente cuando:
 *   1. POST /providers/register fue exitoso
 *   2. POST /providers/documents fue exitoso
 *   3. El backend confirmó la aprobación automática (status: "success")
 * No se dispara si alguno de esos pasos falla.
 */
export function trackCompleteRegistration() {
  safeFbq('track', 'CompleteRegistration');
}

/**
 * ProfessionalProfileCompleted (custom) — se dispara cuando el proveedor
 * guarda sus servicios y medios de pago en el paso de onboarding.
 */
export function trackProfessionalProfileCompleted() {
  safeFbq('trackCustom', 'ProfessionalProfileCompleted');
}

/**
 * ProInterestRegistered (custom) — se dispara cuando el proveedor deja su
 * interés en la suscripción Providers PRO. No implica ningún cobro.
 */
export function trackProInterestRegistered() {
  safeFbq('trackCustom', 'ProInterestRegistered');
}
